
import React, { useState } from "react";
import nexumLogo2 from "../../assets/nexumLogo2.png";

const MainNavbar = () => {
// need this state to avoid eslint error
  const [state, setState] = useState('prova');
    return (
      <nav className="fixed top-0 z-50 w-full bg-dark-blue border-b border-b-white py-4 px-3 md:px-10">
        <div className="flex flex-wrap items-center justify-between mx-auto">
          <h1 className="uppercase text-white font-extrabold text-2xl">saas portal</h1>
          <div>
            <a href="https://flowbite.com/" className="flex items-center">
              <img className="img-fluid h-9 md:h-10" src={nexumLogo2} alt="nexumLogo" />
            </a>
          </div>
          <div className="items-center justify-between hidden w-full md:flex md:w-auto">
            <div className="relative">
              <img className="w-10 h-10 rounded-full" src="https://i.pravatar.cc/300" alt="user avatar" />
              <span className="bottom-0 left-7 absolute  w-3.5 h-3.5 bg-green-400 border-2 border-white dark:border-gray-800 rounded-full" />
            </div>
          </div>
        </div>
      </nav>
    );
};

export default MainNavbar;
